import { ReactNode } from 'react';

interface HeaderProps {
    title: string;
    subtitle?: string;
    actions?: ReactNode;
}

export default function Header({ title, subtitle, actions }: HeaderProps) {
    return (
        <header className="bg-white border-b border-[#E6E9ED] px-6 py-4 flex items-center justify-between">
            <div>
                <h1 className="text-[17px] font-semibold text-[#73879C]">{title}</h1>
                {subtitle && (
                    <p className="text-[12px] text-[#ADB5BD] mt-0.5">{subtitle}</p>
                )}
            </div>
            {actions && <div className="flex items-center gap-3">{actions}</div>}
        </header>
    );
}
